import { jsx as e, jsxs as y, Fragment as S } from "react/jsx-runtime";
import { Slot as h } from "@radix-ui/react-slot";
import { forwardRef as I } from "react";
import { e as P } from "./palettes-DoFdaGi8.js";
import { c as m } from "./cn-DlLpp5ix.js";
const _ = {
  xs: "var(--text-2xs)",
  sm: "var(--text-2xs)",
  md: "var(--text-xs)"
}, k = {
  xs: "var(--space-0_5) var(--space-1_5)",
  sm: "var(--space-0_5) var(--space-2)",
  md: "var(--space-1) var(--space-2_5)"
};
function w(r, a) {
  switch (a) {
    case "solid":
      return {
        bg: r.fg,
        fg: "var(--text-on-accent)",
        border: r.fg,
        borderStyle: "solid"
      };
    case "outline":
      return { bg: "transparent", fg: r.fg, border: r.border, borderStyle: "solid" };
    case "dashed":
      return { bg: "transparent", fg: r.fg, border: r.border, borderStyle: "dashed" };
    case "soft":
    default:
      return { bg: r.bg, fg: r.fg, border: r.border, borderStyle: "solid" };
  }
}
const N = I(function({
  children: a,
  tone: s = "neutral",
  variant: l = "soft",
  size: t = "md",
  icon: o,
  iconRight: i,
  uppercase: d = !1,
  asChild: b = !1,
  className: c,
  style: u,
  ...f
}, p) {
  const v = P[s], n = w(v, l), g = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "var(--space-1)",
    padding: k[t],
    fontSize: _[t],
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: d ? "var(--tracking-uppercase)" : "var(--tracking-snug)",
    textTransform: d ? "uppercase" : "none",
    color: n.fg,
    background: n.bg,
    border: `1px solid ${n.border}`,
    borderStyle: n.borderStyle,
    borderRadius: "var(--radius-pill)",
    maxWidth: "100%",
    ...u
  }, x = /* @__PURE__ */ y(S, { children: [
    o ? /* @__PURE__ */ e("span", { "data-ls-pill-icon": !0, style: { display: "inline-flex", alignItems: "center" }, children: o }) : null,
    /* @__PURE__ */ e(
      "span",
      {
        style: {
          display: "inline-block",
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        children: a
      }
    ),
    i ? /* @__PURE__ */ e("span", { "data-ls-pill-icon-right": !0, style: { display: "inline-flex", alignItems: "center" }, children: i }) : null
  ] });
  return b ? /* @__PURE__ */ e(
    h,
    {
      ref: p,
      "data-ls-component": "pill",
      "data-tone": s,
      "data-variant": l,
      "data-size": t,
      "data-interactive": "true",
      className: m(c),
      style: g,
      ...f,
      children: a
    }
  ) : /* @__PURE__ */ e(
    "span",
    {
      ref: p,
      "data-ls-component": "pill",
      "data-tone": s,
      "data-variant": l,
      "data-size": t,
      className: m(c),
      style: g,
      ...f,
      children: x
    }
  );
});
N.displayName = "Pill";
export {
  N as P
};
//# sourceMappingURL=Pill-uAcQLotY.js.map
